import { createRequest } from "helpers/tools";

export const saveFieldMappingAsync = async (data) => {
    return await createRequest({
        suffix: `lead/save-field-mapping`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const saveTempAsync = async (data) => {
    return await createRequest({
        suffix: `lead/templates`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getIsGroupChangedSourceFields = async (data) => {
    return await createRequest({
        suffix: `lead/get-source-fields-group`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getTemplateDetail = async (id) => {
    return await createRequest({
        suffix: `lead/templates/${id}/fields-mapping`,
        method: "get",
        handleError: false,
    });
};

const parseFilenameFromContentDisposition = (header, fallback) => {
    if (!header) {
        return fallback;
    }
    const utfMatch = header.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
    if (utfMatch?.[1]) {
        try {
            return decodeURIComponent(utfMatch[1].replace(/['"]/g, "").trim());
        } catch {
            return utfMatch[1].replace(/['"]/g, "").trim();
        }
    }
    const quotedMatch = header.match(/filename="([^"]+)"/i);
    if (quotedMatch?.[1]) {
        return quotedMatch[1].trim();
    }
    const plainMatch = header.match(/filename=([^;]+)/i);
    return plainMatch?.[1]?.trim() || fallback;
};

const downloadBlobFile = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
};

export const exportFieldMapping = async (connectionId, fieldMappingId) => {
    const fallback = `field_mapping_${fieldMappingId}_${new Date()
        .toISOString()
        .slice(0, 10)}.json`;
    const response = await createRequest({
        suffix: `lead/connection/${connectionId}/field-mapping/${fieldMappingId}/export`,
        method: "get",
        handleError: false,
        config: { responseType: "blob" },
    });
    if (!response.status) {
        return response;
    }
    const filename = parseFilenameFromContentDisposition(
        response.headers?.["content-disposition"],
        fallback,
    );
    const blob =
        response.data instanceof Blob
            ? response.data
            : new Blob([JSON.stringify(response.data)], {
                  type: "application/json",
              });
    downloadBlobFile(blob, filename);
    return { status: true };
};

export const importFieldMapping = async (data) => {
    return await createRequest({
        suffix: `lead/import-field-mapping`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
